/* eslint-disable */

export default {
  gtmId: 'GTM-TMCRNDF',
  gtmAuth: process.env.REACT_APP_GTM_AUTH,
  apiUrl: process.env.REACT_APP_API_URL,
}
